import { GET, POST, DELETE, PATCH } from '../utils/restUtils';
import { Auth } from 'aws-amplify';
import _ from 'lodash';

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}


export const getShots  = async () => {
  let data = await GET("/shot");
  return data
}

export const getVideoShots  = async (config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers},{
    params:{
      type: "video"
    }
  })
  let data = await GET("/shot",config);
  return data
}

export const getPhotoShots  = async (config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers},{
    params:{
      type: "photo"
    }
  })
  let data = await GET("/shot",config);
  return data
}

export const saveShot = async (update,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await POST("/shot",update,config) 
  return data
}

export const getOneShot = async (key,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await GET(`/shot/${key}`,config);
  return data
}

export const deleteOneShot =  async (key,config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await DELETE(`/shot/${key}`,config);
  return data
}

export const updateOneShot = async (key,update, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  let data = await PATCH(`/shot/${key}`, update, config)
  return data
}

export const addPackage = async (data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return POST(`/packages`, data, config);
}

export const getPackages = async (config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return GET(`/packages`, config);
}

export const getOnePackage = async (id, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return GET(`/packages/${id}`, config);
}

export const getOnePackageDetails = async (id, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return GET(`/packages/${id}?details=1`, config);
};

export const deleteOnePackage = async (id, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return DELETE(`/packages/${id}`, config);
}

export const editOnePackage = async (id, update, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return PATCH(`/packages/${id}`, update, config);
}

export const getPackageShots = async (id, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return GET(`/packages/${id}/shots`, config);
}

export const addShotsToPackage = async (id, data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return POST(`/packages/${id}/shots`, data, config);
}

export const removeShotsFromPackage = async (id, data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers }, { data });
  return DELETE(`/packages/${id}/shots`, config);
}

export const getPackageUnselectedShots = async (id, type, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  
  };
  config = _.assign({}, config, { headers });
  return GET(`/packages/${id}/shots?unselected=1`, config);
}


export default {
  getShots,
  getPhotoShots,
  getVideoShots,
  saveShot,
  getOneShot,
  deleteOneShot,
  updateOneShot,
  addPackage,
  getPackages,
  getOnePackage,
  getOnePackageDetails,
  deleteOnePackage,
  editOnePackage,
  getPackageShots,
  addShotsToPackage,
  removeShotsFromPackage,
  getPackageUnselectedShots,
}



